import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { customTheme } from '../../styling'
import { Box, Dialog, DialogActions, Popover, DialogTitle, Button, Accordion, AccordionSummary, AccordionDetails, TextField, Select, MenuItem, CircularProgress, Typography } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import SnackBar from '../snackbar'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'

const useStyles = makeStyles(() => ({
    titleContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    title: {
        color: customTheme.colors.ui.blue
    },
    contentContainer: {
        padding: '2rem'
    },
    dialogContent: {
        paddingTop: '1.2rem',
        marginTop: '1.2rem',
        borderRadius: '8px',
        border: `1px solid ${customTheme.colors.ui.grey}`
    },
    dialogActions: {
        width: '100%',
        justifyContent: 'center',
        marginTop: '3rem'
    },
    uploadFile: {
        marginLeft: '1rem',
        height: '10vh',
        display: 'flex',
        flexDirection: 'column',
        display: 'flex',
        textAlign: 'center',
        border: `1px solid ${customTheme.colors.ui.grey}`,
        borderStyle: 'dotted',
        marginBottom: '0.3rem'
    },
    accordionSummary: {
        width: '100%',
        padding: '0 1rem !important'
    }
}))



const ChatConfiguration = ({
    handleClose,
    setDescriptionChat,
    descriptionChat,
    setNameChat,
    nameChat,
    handleSaveConfiguration,
    savingConfguration
}) => {
    const classes = useStyles()
    const { enqueueSnackbar } = SnackBar.Consumer()
    const [textAreaFocused, setTextAreaFocused] = useState(false)

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClickPopover = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleClosePopover = () => {
        setAnchorEl(null);
    }

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;


    return (

        <Dialog
            fullWidth={true}
            maxWidth="md"
            className={classes.dialogContainer}
            open={true}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Box className={classes.contentContainer}>
                <Box className={classes.titleContainer}>
                    <DialogTitle id="alert-dialog-title" className={classes.title}>
                        Personalizza la tua chat
                    </DialogTitle>
                </Box>
                <div>

                    <Typography
                        className={classes.accordionSummary}
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        Scegli un nome per la tua chat
                    </Typography>
                    <AccordionDetails style={{ color: customTheme.colors.ui.greyDark }}>
                        Questo ti aiuterà a trovarla facilmente nella lista della chat
                    </AccordionDetails>
                    <Popover
                        id={id}
                        // anchorReference="anchorPosition"
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClosePopover}
                        // anchorPosition={{ top: 420, left: 730 }}
                        transformOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        // anchorOrigin={{
                        //     vertical: 'bottom',
                        //     horizontal: 'center',
                        // }}
                        PaperProps={{
                            style: {
                                paddingTop:'1rem',
                                borderRadius: 15, 
                                border: `1px solid #cbcbcbff`,
                            },
                        }}
                    >
                        <Box style={{ padding: '1rem', paddingRight:'2rem' }}>
                            <span style={{ fontWeight: 'bold', marginLeft: '1.5rem' }}>Alcuni suggerimenti:</span>
                            <ul style={{ lineHeight: 2 }}>
                                <li>Qual è il tuo ruolo all'interno della banca? In quale dipartimento lavori?</li>
                                <li>Quali sono le tue principali responsabilità quotidiane?</li>
                                <li>Ci sono strumenti o processi che utilizzi regolarmente e su cui potrei esserti d'aiuto?</li>
                                <li>Quali sono gli obiettivi principali che vuoi raggiungere nel tuo lavoro?</li>
                                <li>Hai collaborato recentemente a progetti o iniziative interessanti?</li>
                            </ul>
                        </Box>
                    </Popover>
                    <AccordionDetails style={{ color: customTheme.colors.ui.greyDark, width: '100%' }}>
                        <TextField value={nameChat} onChange={(event) => setNameChat(event.target.value)} variant="outlined" style={{ width: '100%', }} placeholder='Esempio: esperto di marketing' />
                    </AccordionDetails>


                    <Typography

                        className={classes.accordionSummary}
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        Cosa pensi dovrebbe sapere di te la Chat per darti risposte migliori?
                    </Typography>
                    <Box style={{padding:'14px 20px'}}>
                    <AccordionDetails style={{ padding:'0.5rem', borderRadius:'4px', border: textAreaFocused ? `2px solid ${customTheme.colors.ui.red}` : `1px solid #d9d9d9`, color: customTheme.colors.ui.greyDark, width: '100%', borderRadius:15 }}>
                        <textarea onFocus={() => setTextAreaFocused(true)}
                      onBlur={() => setTextAreaFocused(false)} value={descriptionChat} onChange={(event) => setDescriptionChat(event.target.value)} style={{ 
                        
                     font:'inherit',
                    fontSize: '1rem',  resize: 'none', width: '100%',border: 'none',
                    outline: "none",
                    background: 'transparent', height: '28vh', }} placeholder={`Lavoro nel dipartimento Marketing della banca, dove mi occupo di sviluppare e implementare strategie per promuovere i nostri prodotti e servizi. Le mie responsabilità quotidiane includono l’analisi di mercato, la gestione delle campagne pubblicitarie e la creazione di contenuti per i canali digitali. Utilizzo regolarmente strumenti come piattaforme di marketing automation e software di analisi dei dati per monitorare le performance delle campagne e ottimizzarne i risultati. Al momento, il mio obiettivo principale è aumentare l’engagement dei clienti attraverso iniziative personalizzate e mirate. Recentemente, ho collaborato a un progetto volto a migliorare la comunicazione digitale, ottenendo risultati significativi in termini di conversioni.`} />

                    </AccordionDetails>
                    </Box>


                    {open ?
                        <Typography onClick={handleClosePopover} style={{ float: 'right', marginRight: '1rem', cursor: 'pointer' }}><VisibilityOffIcon style={{ position: 'relative', top: '0.5rem' }} /> Nascondi suggerimenti</Typography>
                        : <Typography onClick={handleClickPopover} style={{ float: 'right', marginRight: '1rem', cursor: 'pointer' }}><VisibilityIcon style={{ position: 'relative', top: '0.5rem' }} /> Mostra suggerimenti</Typography>}



                </div>


                <DialogActions className={classes.dialogActions}>
                    <Button style={{ width: '6rem' }} onClick={handleClose} variant='contained' color='default'>Annulla</Button>
                    <Button disabled={!descriptionChat || !nameChat} style={{ width: '6rem' }} onClick={() => handleSaveConfiguration()} variant='contained' color='primary'>
                        {savingConfguration ? <CircularProgress style={{ color: 'white' }} size={22} /> : 'Salva'}
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ChatConfiguration